/**
 * Theme Constants for Fjernvarme Skælskør Simulation
 * Forsyning Danmark Professional Theme
 * Now with Ant Design integration
 */

// Ant Design Theme Configuration
export const ANT_THEME = {
  token: {
    colorPrimary: '#003918', // Forsyning Danmark green
    colorSuccess: '#00572a',
    colorWarning: '#D97706',
    colorError: '#DC2626',
    colorInfo: '#1E40AF',
    borderRadius: 4,
    fontSize: 14,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
  },
  components: {
    Card: {
      borderRadiusLG: 6,
      paddingLG: 12,
    },
    Statistic: {
      titleFontSize: 12,
      contentFontSize: 20,
    },
    Button: {
      borderRadius: 4,
      controlHeight: 32,
    },
  },
};

export const COLORS = {
  // Forsyning Danmark Primary Colors
  primary: {
    green: '#003918',
    greenLight: '#00572a',
    greenDark: '#002310',
  },
  
  // Energy Type Colors - Muted Professional Palette
  solar: '#F59E0B',      // Amber - Solar energy
  electricity: '#00572a', // FD Green - Electricity/Grid
  heat: '#DC2626',       // Red - Heat production
  waste: '#059669',      // Emerald - Waste heat
  storage: '#7C3AED',    // Violet - Storage systems
  
  // Operational Colors - Professional Palette
  operational: {
    heater: '#991B1B',     // Dark red for electric heater
    turbine: '#4C1D95',    // Dark purple for turbine
    htes: '#92400E',       // Dark amber for HTES
    ltes: '#7C2D12',       // Dark orange for LTES
    battery: '#374151',    // Gray for battery
    anPlant: '#7F1D1D',    // Deep red for An-værk
    abPlant: '#991B1B',    // Darker red for Ab-værk
    production: '#DC2626', // Red for production chain
  },
  
  // Additional specific colors
  wasteHeat: '#059669',    // Emerald - Waste heat recovery
  battery: '#6B7280',      // Gray - Battery systems
  
  // Financial Colors - Corporate Palette
  financial: {
    revenue: '#00572a',    // FD Green for revenue
    cost: '#991B1B',       // Dark red for costs
    opex: '#1E40AF',       // Dark blue for OPEX
    capex: '#6B21A8',      // Dark purple for CAPEX
    profit: '#00572a',     // FD Green for profit
    loss: '#991B1B',       // Dark red for loss
  },
  
  // Status Colors
  status: {
    success: '#00572a',    // FD Green - Success
    warning: '#D97706',    // Amber - Warning
    error: '#DC2626',      // Red - Error
    info: '#1E40AF',       // Blue - Information
    neutral: '#6B7280',    // Gray - Neutral
  },
  
  // UI Colors - Clean Professional
  ui: {
    background: '#FCFCFC',
    surface: '#FFFFFF',
    border: '#E0E0E0',
    text: {
      primary: '#222222',
      secondary: '#444444',
      muted: '#666666',
      disabled: '#999999',
    }
  }
};

export const CARD_SIZES = {
  small: {
    minWidth: '160px',
    maxWidth: '100%',
    padding: '0.25rem',
  },
  medium: {
    minWidth: '200px',
    maxWidth: '100%',
    padding: '0.375rem',
  },
  large: {
    minWidth: '280px',
    maxWidth: '100%',
    padding: '0.5rem',
  },
  fullWidth: {
    width: '100%',
    padding: '0.5rem',
  }
};

export const BREAKPOINTS = {
  mobile: '640px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1280px',
  ultrawide: '1536px',
};

export const TRANSITIONS = {
  fast: '150ms ease',
  normal: '250ms ease',
  slow: '350ms ease',
};

export const SHADOWS = {
  sm: 'rgba(0, 0, 0, 0.02) 0px 1px 2px 0px',
  md: 'rgba(0, 0, 0, 0.04) 0px 1px 3px 0px',
  lg: 'rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
  xl: 'rgba(0, 0, 0, 0.08) 0px 4px 8px -2px',
};

export const GRADIENTS = {
  heat: 'linear-gradient(135deg, #FF6B6B 0%, #FF5722 100%)',
  solar: 'linear-gradient(135deg, #FFC107 0%, #FFB300 100%)',
  electricity: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
  storage: 'linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%)',
  profit: 'linear-gradient(135deg, #27AE60 0%, #2ECC71 100%)',
  loss: 'linear-gradient(135deg, #E74C3C 0%, #C0392B 100%)',
};
